export const UserAttributeName = {
  HasDismissedInvoiceSyncErrorBanner: 'SyncErrorVisibility:HasDismissedInvoiceSyncErrorBanner'
};